import React, { useEffect, useState } from "react";
import Pagination from "react-js-pagination";
import ConfigDB from "../../config";
import { toast } from "react-toastify";
import Utils from "../../utils";
import {
  Button,
  Form,
  FormGroup,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from "reactstrap";
import { useLocation, useNavigate } from "react-router-dom";
import Dropdown from "react-bootstrap/Dropdown";
import { useTranslation } from "react-i18next";
import ReactPaginate from "react-paginate";
import {
  createTemplate,
  deleteTemplate,
  getAllTemplateSync,
  getListCountry,
  getTemplateList,
  updateTemplate,
} from "../../services/MoloniServices";
import Select from "react-select";

const IdentificationTemplates = () => {
  const tableLengthList = ConfigDB.data.dataTableLength;
  const data = localStorage.getItem(ConfigDB.data.login_data);
  const companyId = JSON.parse(data);
  const navigate = useNavigate();

  const location = useLocation();
  const [activeTab, setActiveTab] = useState("tpsoft");

  const [params, setParams] = useState({
    limit: tableLengthList[0],
    page: 1,
    search: "",
    is_reload: false,
    company_id: "269134",
    created_from: activeTab === "tpsoft" ? 1 : 2,
  });
  const { t } = useTranslation();

  const [totalRecords, setTotalRecords] = useState(0);
  const [templateList, setTemplateList] = useState([]);
  const [delModal, setDelModal] = useState(false);
  const [isDelButtonLoad, setIsDelButtonLoad] = useState(false);
  const [delType, setDelType] = useState("");
  const [modifyModal, setModifyModal] = useState(false);
  const [isModifyButtonLoad, setIsModifyButtonLoad] = useState(false);
  const [templateData, setTemplateData] = useState({
    id: "",
    name: "",
    business_name: "",
    email: "",
    address: "",
    city: "",
    zip_code: "",
    phone: "",
    fax: "",
    website: "",
    notes: "",
    documents_footnote: "",
    email_sender_name: "",
    email_sender_address: "",
    country_id: "",
    moloni_id: "",
  });

  let errorsObj = {
    name: "",
    business_name: "",
    email: "",
    address: "",
    city: "",
    zip_code: "",
    phone: "",
    fax: "",
    website: "",
    notes: "",
    documents_footnote: "",
    email_sender_name: "",
    email_sender_address: "",
    country_id: "",
  };
  const [errors, setErrors] = useState(errorsObj);
  const [timeZoneList, setTimeZoneList] = useState([]);
  const [isIdentificationLoading, setIsIdentificationLoading] = useState(false);

  const handleTabChange = (tab) => {
    setActiveTab(tab);

    setParams((prevParams) => ({
      ...prevParams,
      created_from: tab === "tpsoft" ? 1 : 2,
    }));
  };

  const handleAddModal = () => {
    setModifyModal(true);
  };

  const handleCloseModal = () => {
    setModifyModal(false);
    setTemplateData({
      id: "",
      name: "",
      business_name: "",
      email: "",
      address: "",
      city: "",
      zip_code: "",
      phone: "",
      fax: "",
      website: "",
      notes: "",
      documents_footnote: "",
      email_sender_name: "",
      email_sender_address: "",
      country_id: "",
      moloni_id: "",
    });

    setErrors("");
  };
  useEffect(() => {
    const currentPath = location.pathname;
    const savedPath = localStorage.getItem("lastVisitedPath");

    if (savedPath && savedPath !== currentPath) {
      localStorage.removeItem("lastVisitedPage");
      localStorage.removeItem("searchValue");
    }

    localStorage.setItem("lastVisitedPath", currentPath);

    const savedPage = localStorage.getItem("lastVisitedPage");
    const storedSearch = localStorage.getItem("searchValue") || "";

    setParams((prevParams) => ({
      ...prevParams,
      search: storedSearch,
      page: savedPage ? parseInt(savedPage, 10) : 1,
    }));
  }, [location.pathname]);

  const handleParams = (e, type) => {
    let paramsObj = { ...params };
    if (type === "length") {
      paramsObj.limit = e.target.value;
    } else if (type === "search") {
      paramsObj.page = 1;
      paramsObj.search = e.target.value;
      localStorage.setItem("searchValue", e.target.value);
      localStorage.removeItem("lastVisitedPage");
    } else if (type === "pagination") {
      paramsObj.page = e.selected + 1;
      localStorage.setItem("lastVisitedPage", e.selected + 1);
    }
    setParams(paramsObj);
  };

  const fetchTemplate = () => {
    let data = { ...params };
    getTemplateList(data)
      .then((response) => {
        setTemplateList(response.data.data);
        setTotalRecords(response.data.total);
      })
      .catch((err) => {
        toast.error(Utils.getErrorMessage(err));
      });
  };

  useEffect(
    function () {
      let data = { ...params };

      fetchTemplate(data);
    },
    [params],
  );

  const handleTemplateSync = () => {
    setIsIdentificationLoading(true);

    let data = { company_id: "269134" };
    getAllTemplateSync(data)
      .then((response) => {
        toast.success(response.data.message);

        let data = { ...params };
        getTemplateList(data)
          .then((response) => {
            setTemplateList(response.data.data);
            setTotalRecords(response.data.total);
          })
          .catch((err) => {
            toast.error(Utils.getErrorMessage(err));
          })
          .finally(() => {
            setIsIdentificationLoading(false);
          });
      })
      .catch((err) => {
        toast.error(Utils.getErrorMessage(err));
        setIsIdentificationLoading(false);
      });
  };

  useEffect(function () {
    let data = {
      limit: 20,
      page: 1,
      search: "",
    };
    getListCountry(data)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].id,
            label: response.data[i].name,
          });
        }

        setTimeZoneList(list);
      })
      .catch((err) => {});
  }, []);

  const onDeleteModalClose = () => {
    setDelModal(false);
  };

  const onDeleteModalOpen = (e, item) => {
    e.preventDefault();
    setDelType(item.moloni_id);
    setDelModal(true);
  };

  const onDestroyBank = (e) => {
    e.preventDefault();
    setIsDelButtonLoad(true);
    let data = { template_id: delType, company_id: "269134" };
    deleteTemplate(data)
      .then((response) => {
        let data = { ...params };

        fetchTemplate(data);
        toast.success(response.data.message);
        setDelType("");
        setDelModal(false);
        setIsDelButtonLoad(false);
      })
      .catch((err) => {
        setIsDelButtonLoad(false);
        toast.error(Utils.getErrorMessage(err));
      });
  };

  const handleSubmitForm = (e) => {
    e.preventDefault();
    let error = false;
    let errorObj = { ...errorsObj };
    if (!templateData.name) {
      errorObj.name = `Name is required.`;
      error = true;
    }

    if (!templateData.business_name) {
      errorObj.business_name = `Business name is required.`;
      error = true;
    }

    if (!templateData.email) {
      errorObj.email = `Email is required.`;
      error = true;
    }

    if (!templateData.address) {
      errorObj.address = `Address is required.`;
      error = true;
    }

    if (!templateData.city) {
      errorObj.city = `City is required.`;
      error = true;
    }

    if (!templateData.zip_code) {
      errorObj.zip_code = `Zip code is required.`;
      error = true;
    }

    if (!templateData.email_sender_name) {
      errorObj.email_sender_name = `Email Sender Name is required.`;
      error = true;
    }

    if (!templateData.email_sender_address) {
      errorObj.email_sender_address = `Email Sender Address is required.`;
      error = true;
    }

    if (!templateData.country_id) {
      errorObj.country_id = `Country is required.`;
      error = true;
    }

    if (templateData.website) {
      const isValidUrl = /^https?:\/\//.test(templateData.website);
      if (!isValidUrl) {
        errorObj.website = "Website must start with http:// or https://";
        error = true;
      }
    }

    setErrors(errorObj);
    Utils.focusError();

    if (error) return;

    setIsModifyButtonLoad(true);

    let data = {
      company_id: "269134",
      name: templateData?.name,
      business_name: templateData?.business_name,
      email: templateData?.email,
      address: templateData?.address,
      city: templateData?.city,
      zip_code: templateData?.zip_code,
      phone: templateData?.phone,
      fax: templateData?.fax,
      website: templateData?.website,
      notes: templateData?.notes,
      documents_footnote: templateData?.documents_footnote,
      email_sender_name: templateData?.email_sender_name,
      email_sender_address: templateData?.email_sender_address,
      country_id: templateData?.country_id,
    };

    let updateData = {
      company_id: "269134",
      id: templateData?.id,
      name: templateData?.name,
      business_name: templateData?.business_name,
      email: templateData?.email,
      address: templateData?.address,
      city: templateData?.city,
      zip_code: templateData?.zip_code,
      phone: templateData?.phone,
      fax: templateData?.fax,
      website: templateData?.website,
      notes: templateData?.notes,
      documents_footnote: templateData?.documents_footnote,
      email_sender_name: templateData?.email_sender_name,
      email_sender_address: templateData?.email_sender_address,
      country_id: templateData?.country_id,
      template_id: templateData?.moloni_id,
    };

    if (templateData?.id) {
      updateTemplate(updateData)
        .then((response) => {
          toast.success(response.data.message);
          let data = { ...params };
          fetchTemplate(data);
          setModifyModal(false);
          setIsModifyButtonLoad(false);
          setTemplateData({
            id: "",
            name: "",
            business_name: "",
            email: "",
            address: "",
            city: "",
            zip_code: "",
            phone: "",
            fax: "",
            website: "",
            notes: "",
            documents_footnote: "",
            email_sender_name: "",
            email_sender_address: "",
            country_id: "",
            moloni_id: "",
          });
        })
        .catch((err) => {
          toast.error(Utils.getErrorMessage(err));
          setIsModifyButtonLoad(false);
        });
    } else {
      createTemplate(data)
        .then((response) => {
          toast.success(response.data.message);
          let data = { ...params };
          fetchTemplate(data);
          setModifyModal(false);
          setIsModifyButtonLoad(false);
          setTemplateData({
            id: "",
            name: "",
            business_name: "",
            email: "",
            address: "",
            city: "",
            zip_code: "",
            phone: "",
            fax: "",
            website: "",
            notes: "",
            documents_footnote: "",
            email_sender_name: "",
            email_sender_address: "",
            country_id: "",
            moloni_id: "",
          });
        })
        .catch((err) => {
          toast.error(Utils.getErrorMessage(err));
          setIsModifyButtonLoad(false);
        });
    }
  };

  return (
    <div>
      <div>
        <section className="content-header">
          <div className="container-fluid container-custom-height-new">
            <div className="row mb-2">
              <div className="col-sm-12 d-flex align-items-center">
                <button
                  type="button"
                  className="next-button btn btn-secondary"
                  onClick={() => navigate("/moloni-settings")}
                >
                  <i className="bi bi-arrow-left"></i> {t("back")}
                </button>
                <h1 className="page-title ms-auto mb-2">
                  {t("identificationTemplates")}
                </h1>
              </div>
            </div>
          </div>
        </section>

        <section className="content">
          <div className="container-fluid container-custom-height-new">
            <div className="row">
              <div className="col-md-12">
                <div className="card fuelCard">
                  <div className="card-header">
                    <div
                      className="card-title m-0 float-left"
                      style={{ width: "50%" }}
                    >
                      <input
                        type="text"
                        className="form-control input-search"
                        value={params.search}
                        onChange={(e) => handleParams(e, "search")}
                        placeholder="Search"
                      ></input>
                    </div>

                    <div className="card-title m-0 float-right d-flex">
                      <button
                        type="button"
                        className="btn  btn-icon-text mr-2"
                        onClick={() =>
                          navigate("/add-identification-templates")
                        }
                      >
                        <i className="bi bi-plus-lg"></i>
                        <span className="ms-2">{t("Add")}</span>
                      </button>

                      {activeTab === "moloni" && (
                        <button
                          type="button"
                          className="btn mr-2"
 style={{
                            background: "#81bb42",
                            width: "52px",
                            height: "36px",
                          }}                          onClick={handleTemplateSync}
                          disabled={isIdentificationLoading}
                        >
                          {isIdentificationLoading ? (
                            <span
                              className="spinner-border spinner-border-sm"
                              role="status"
                              aria-hidden="true"
                            ></span>
                          ) : (
                            <i className="bi bi-arrow-repeat"></i>
                          )}
                        </button>
                      )}
                    </div>
                  </div>
                  <div className="card-body fuelCardB">
                    <div className="tabs-section">
                      <ul className="nav nav-tabs">
                        <li className="nav-item">
                          <a
                            className={`nav-link ${
                              activeTab === "tpsoft" ? "active" : ""
                            }`}
                            onClick={() => handleTabChange("tpsoft")}
                            style={{ cursor: "pointer" }}
                          >
                            TPSoft
                          </a>
                        </li>

                        <li className="nav-item">
                          <a
                            className={`nav-link ${
                              activeTab === "moloni" ? "active" : ""
                            }`}
                            onClick={() => handleTabChange("moloni")}
                            style={{ cursor: "pointer" }}
                          >
                            Moloni
                          </a>
                        </li>
                      </ul>

                      <div className="tab-content">
                        <div
                          className={`tab-pane fade ${
                            activeTab === "tpsoft" ? "show active" : ""
                          }`}
                        >
                          <div
                            className="vehicleThBg table-responsive  table-responsive-vehicle"
                            style={{ marginTop: "15px" }}
                          >
                            <table className="table table-bordered">
                              <thead>
                                <tr>
                                  <th
                                    className="col-form-label ml-2 Label-my form-label form-label"
                                    style={{ width: "10%" }}
                                  >
                                    {t("name")}
                                  </th>

                                  <th
                                    className="col-form-label ml-2 Label-my form-label form-label"
                                    style={{ width: "10%" }}
                                  >
                                    {t("business_name")}
                                  </th>

                                  <th
                                    className="col-form-label ml-2 Label-my form-label form-label"
                                    style={{ width: "10%" }}
                                  >
                                    {t("email")}
                                  </th>

                                  <th
                                    className="col-form-label ml-2 Label-my form-label form-label"
                                    style={{ width: "10%" }}
                                  >
                                    {t("phone")}
                                  </th>
                                  <th
                                    className="col-form-label ml-2 Label-my form-label form-label"
                                    style={{ width: "10%" }}
                                  >
                                    {t("email_sender_address")}
                                  </th>
                                  <th
                                    className="col-form-label ml-2 Label-my form-label form-label"
                                    style={{ width: "10%" }}
                                  >
                                    {t("email_sender_name")}
                                  </th>

                                  <th
                                    className="col-form-label ml-2 Label-my form-label form-label"
                                    style={{ width: "0%" }}
                                  >
                                    {t("action")}
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                {templateList?.map((item, index) => {
                                  return (
                                    <>
                                      <tr>
                                        <td>{item.name}</td>
                                        <td>{item.business_name}</td>
                                        <td>{item.email}</td>
                                        <td>{item.phone}</td>
                                        <td>
                                          {item.email_sender_address || "-"}
                                        </td>
                                        <td>{item.email_sender_name}</td>

                                        <td className="d-flex">
                                          <Dropdown
                                            className="iconDropdown"
                                            onToggle={(isOpen) => {
                                              if (isOpen) {
                                                // This logic runs when the dropdown is opened
                                                const tableResponsive =
                                                  document.querySelector(
                                                    ".table-responsive",
                                                  );
                                                if (window.innerWidth <= 767) {
                                                  if (tableResponsive) {
                                                    tableResponsive.style.overflowX =
                                                      "auto !important";
                                                    tableResponsive.style.overflowY =
                                                      "auto !important";
                                                  }
                                                } else {
                                                  if (tableResponsive) {
                                                    tableResponsive.style.overflowX =
                                                      "inherit !important";
                                                    tableResponsive.style.overflowY =
                                                      "inherit !important";
                                                  }
                                                }
                                              }
                                            }}
                                          >
                                            <Dropdown.Toggle
                                              variant="success"
                                              id="dropdown-basic"
                                              className="iconToggle"
                                            >
                                              <i className="bi bi-three-dots-vertical"></i>
                                            </Dropdown.Toggle>

                                            <Dropdown.Menu>
                                              <Dropdown.Item
                                                href="#/action-1"
                                                className="d-flex"
                                                onClick={() =>
                                                  navigate(
                                                    `/update-identification-templates/${item.id}`,
                                                    {
                                                      state: item,
                                                    },
                                                  )
                                                }
                                              >
                                                <div className="edit-btn">
                                                  <i className="bi bi-pencil"></i>
                                                </div>
                                                <span>{t("edit")}</span>
                                              </Dropdown.Item>
                                              <Dropdown.Item
                                                href="#/action-2"
                                                className="d-flex"
                                                onClick={(e) =>
                                                  onDeleteModalOpen(e, item)
                                                }
                                              >
                                                <div className="trash-btn">
                                                  <a className="delete-btn">
                                                    <i className="bi bi-trash3"></i>
                                                  </a>
                                                </div>
                                                <span>{t("delete")}</span>
                                              </Dropdown.Item>
                                            </Dropdown.Menu>
                                          </Dropdown>
                                        </td>
                                      </tr>
                                    </>
                                  );
                                })}
                              </tbody>
                              {templateList && templateList?.length === 0 && (
                                <tr>
                                  <td colSpan={7} className={`text-center`}>
                                    {t("no_record_found")}
                                  </td>
                                </tr>
                              )}
                            </table>
                          </div>
                        </div>

                        <div
                          className={`tab-pane fade ${
                            activeTab === "moloni" ? "show active" : ""
                          }`}
                        >
                          <div
                            className="vehicleThBg table-responsive table-responsive1  table-responsive-vehicle"
                            style={{ marginTop: "15px" }}
                          >
                            <table className="table table-bordered">
                              <thead>
                                <tr>
                                  <th
                                    className="col-form-label ml-2 Label-my form-label form-label"
                                    style={{ width: "10%" }}
                                  >
                                    {t("name")}
                                  </th>

                                  <th
                                    className="col-form-label ml-2 Label-my form-label form-label"
                                    style={{ width: "10%" }}
                                  >
                                    {t("business_name")}
                                  </th>

                                  <th
                                    className="col-form-label ml-2 Label-my form-label form-label"
                                    style={{ width: "10%" }}
                                  >
                                    {t("email")}
                                  </th>

                                  <th
                                    className="col-form-label ml-2 Label-my form-label form-label"
                                    style={{ width: "10%" }}
                                  >
                                    {t("phone")}
                                  </th>
                                  <th
                                    className="col-form-label ml-2 Label-my form-label form-label"
                                    style={{ width: "10%" }}
                                  >
                                    {t("email_sender_address")}
                                  </th>
                                  <th
                                    className="col-form-label ml-2 Label-my form-label form-label"
                                    style={{ width: "10%" }}
                                  >
                                    {t("email_sender_name")}
                                  </th>

                                  <th
                                    className="col-form-label ml-2 Label-my form-label form-label"
                                    style={{ width: "0%" }}
                                  >
                                    {t("action")}
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                {templateList?.map((item, index) => {
                                  return (
                                    <>
                                      <tr>
                                        <td>{item.name}</td>
                                        <td>{item.business_name}</td>
                                        <td>{item.email}</td>
                                        <td>{item.phone}</td>
                                        <td>
                                          {item.email_sender_address || "-"}
                                        </td>
                                        <td>{item.email_sender_name}</td>

                                        <td className="d-flex">
                                          <Dropdown
                                            className="iconDropdown"
                                            onToggle={(isOpen) => {
                                              if (isOpen) {
                                                // This logic runs when the dropdown is opened
                                                const tableResponsive1 =
                                                  document.querySelector(
                                                    ".table-responsive1",
                                                  );
                                                if (window.innerWidth <= 767) {
                                                  if (tableResponsive1) {
                                                    tableResponsive1.style.overflowX =
                                                      "auto !important";
                                                    tableResponsive1.style.overflowY =
                                                      "auto !important";
                                                  }
                                                } else {
                                                  if (tableResponsive1) {
                                                    tableResponsive1.style.overflowX =
                                                      "inherit !important";
                                                    tableResponsive1.style.overflowY =
                                                      "inherit !important";
                                                  }
                                                }
                                              }
                                            }}
                                          >
                                            <Dropdown.Toggle
                                              variant="success"
                                              id="dropdown-basic"
                                              className="iconToggle"
                                            >
                                              <i className="bi bi-three-dots-vertical"></i>
                                            </Dropdown.Toggle>

                                            <Dropdown.Menu>
                                              <Dropdown.Item
                                                href="#/action-1"
                                                className="d-flex"
                                                onClick={() =>
                                                  navigate(
                                                    `/update-identification-templates/${item.id}`,
                                                    {
                                                      state: item,
                                                    },
                                                  )
                                                }
                                              >
                                                <div className="edit-btn">
                                                  <i className="bi bi-pencil"></i>
                                                </div>
                                                <span>{t("edit")}</span>
                                              </Dropdown.Item>
                                              <Dropdown.Item
                                                href="#/action-2"
                                                className="d-flex"
                                                onClick={(e) =>
                                                  onDeleteModalOpen(e, item)
                                                }
                                              >
                                                <div className="trash-btn">
                                                  <a className="delete-btn">
                                                    <i className="bi bi-trash3"></i>
                                                  </a>
                                                </div>
                                                <span>{t("delete")}</span>
                                              </Dropdown.Item>
                                            </Dropdown.Menu>
                                          </Dropdown>
                                        </td>
                                      </tr>
                                    </>
                                  );
                                })}
                              </tbody>
                              {templateList && templateList?.length === 0 && (
                                <tr>
                                  <td colSpan={7} className={`text-center`}>
                                    {t("no_record_found")}
                                  </td>
                                </tr>
                              )}
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="fuelCF">
            <div
              className="card-footer card-footer-part clearfix card-footer"
              style={{ marginTop: "-26px" }}
            >
              <div className="pagination pagination-sm m-0 float-right">
                <ReactPaginate
                  previousLabel={<i className="bi bi-chevron-double-left"></i>}
                  nextLabel={<i className="bi bi-chevron-double-right"></i>}
                  breakLabel={"..."}
                  pageCount={Math.ceil(totalRecords / params.limit)}
                  marginPagesDisplayed={2}
                  pageRangeDisplayed={5}
                  onPageChange={(e) => handleParams(e, "pagination")}
                  forcePage={params.page - 1}
                  containerClassName={"pagination"}
                  activeClassName={"active"}
                  pageClassName={"page-item"}
                  pageLinkClassName={"page-link"}
                />
              </div>
            </div>
          </div>
        </section>
      </div>

      <Modal isOpen={delModal}>
        <ModalHeader>{t("delete_identification_templates")}</ModalHeader>
        <ModalBody>
          <p className={`mb-0`}>
            {t("Are you sure you want to delete this identification templates")}
          </p>
        </ModalBody>
        <ModalFooter>
          <button
            type="button"
            className="btn btn-block btn-primary"
            disabled={isDelButtonLoad}
            onClick={onDeleteModalClose}
            style={{ width: "100px", marginTop: "10px" }}
          >
            {t("close")} <i className="bi bi-x-lg"></i>
          </button>

          {!isDelButtonLoad && (
            <button
              type="button"
              className="btn btn-block bg-red"
              style={{ width: "100px" }}
              onClick={onDestroyBank}
            >
              {t("delete")} <i className="bi bi-trash3"></i>
            </button>
          )}
          {isDelButtonLoad && (
            <button
              color="secondary"
              type={`button`}
              disabled={true}
              className={`btn-square`}
            >
              <i className="fa fa-circle-o-notch fa-spin"></i> {`Loading...`}
            </button>
          )}
        </ModalFooter>
      </Modal>

      <Modal isOpen={modifyModal} size="lg">
        <ModalHeader>{t("identificationTemplates")}</ModalHeader>
        <Form method={`post`} onSubmit={handleSubmitForm}>
          <ModalBody>
            <div className="row">
              <div className="col-md-3">
                <FormGroup>
                  <Label className="col-form-label ml-2 Label-my">
                    {t("name")}
                  </Label>
                  <div className="col-xl-12">
                    <div className="input-div">
                      <input
                        className="form-control input-search"
                        type="text"
                        value={templateData.name}
                        onChange={(e) => {
                          setTemplateData({
                            ...templateData,
                            name: e.target.value,
                          });
                        }}
                        name={`name`}
                        maxLength={50}
                        placeholder="Name"
                      />
                    </div>
                    {errors.name && (
                      <span className="input-error">{errors.name}</span>
                    )}
                  </div>
                </FormGroup>
              </div>

              <div className="col-md-3">
                <FormGroup>
                  <Label className="col-form-label ml-2 Label-my">
                    {t("business_name")}
                  </Label>
                  <div className="col-xl-12">
                    <div className="input-div">
                      <input
                        className="form-control input-search"
                        type="text"
                        value={templateData.business_name}
                        onChange={(e) => {
                          setTemplateData({
                            ...templateData,
                            business_name: e.target.value,
                          });
                        }}
                        name={`business_name`}
                        maxLength={50}
                        placeholder="Business name"
                      />
                    </div>
                    {errors.business_name && (
                      <span className="input-error">
                        {errors.business_name}
                      </span>
                    )}
                  </div>
                </FormGroup>
              </div>

              <div className="col-md-3">
                <FormGroup>
                  <Label className="col-form-label ml-2 Label-my">
                    {t("email")}
                  </Label>
                  <div className="col-xl-12">
                    <div className="input-div">
                      <input
                        className="form-control input-search"
                        type="text"
                        value={templateData.email}
                        onChange={(e) => {
                          setTemplateData({
                            ...templateData,
                            email: e.target.value,
                          });
                        }}
                        name={`email`}
                        maxLength={50}
                        placeholder="Email"
                      />
                    </div>
                    {errors.email && (
                      <span className="input-error">{errors.email}</span>
                    )}
                  </div>
                </FormGroup>
              </div>

              <div className="col-md-3">
                <FormGroup>
                  <Label className="col-form-label ml-2 Label-my">
                    {t("address")}
                  </Label>
                  <div className="col-xl-12">
                    <div className="input-div">
                      <input
                        className="form-control input-search"
                        type="text"
                        value={templateData.address}
                        onChange={(e) => {
                          setTemplateData({
                            ...templateData,
                            address: e.target.value,
                          });
                        }}
                        name={`address`}
                        maxLength={50}
                        placeholder="Address"
                      />
                    </div>
                    {errors.address && (
                      <span className="input-error">{errors.address}</span>
                    )}
                  </div>
                </FormGroup>
              </div>

              <div className="col-md-3">
                <FormGroup>
                  <Label className="col-form-label ml-2 Label-my">
                    {t("city")}
                  </Label>
                  <div className="col-xl-12">
                    <div className="input-div">
                      <input
                        className="form-control input-search"
                        type="text"
                        value={templateData.city}
                        onChange={(e) => {
                          setTemplateData({
                            ...templateData,
                            city: e.target.value,
                          });
                        }}
                        name={`city`}
                        maxLength={50}
                        placeholder="City"
                      />
                    </div>
                    {errors.city && (
                      <span className="input-error">{errors.city}</span>
                    )}
                  </div>
                </FormGroup>
              </div>

              <div className="col-md-3">
                <FormGroup>
                  <Label className="col-form-label ml-2 Label-my">
                    {t("zip_code")}
                  </Label>
                  <div className="col-xl-12">
                    <div className="input-div">
                      <input
                        className="form-control input-search"
                        type="text"
                        value={templateData.zip_code}
                        onChange={(e) => {
                          setTemplateData({
                            ...templateData,
                            zip_code: e.target.value,
                          });
                        }}
                        name={`zip_code`}
                        maxLength={50}
                        placeholder="Zip code"
                      />
                    </div>
                    {errors.zip_code && (
                      <span className="input-error">{errors.zip_code}</span>
                    )}
                  </div>
                </FormGroup>
              </div>

              <div className="col-md-3">
                <FormGroup>
                  <Label className="col-form-label ml-2 Label-my">
                    {t("phone")}
                  </Label>
                  <div className="col-xl-12">
                    <div className="input-div">
                      <input
                        className="form-control input-search"
                        type="number"
                        value={templateData.phone}
                        onChange={(e) => {
                          setTemplateData({
                            ...templateData,
                            phone: e.target.value,
                          });
                        }}
                        name={`phone`}
                        placeholder="Phone"
                      />
                    </div>
                  </div>
                </FormGroup>
              </div>

              <div className="col-md-3">
                <FormGroup>
                  <Label className="col-form-label ml-2 Label-my">
                    {t("fax")}
                  </Label>
                  <div className="col-xl-12">
                    <div className="input-div">
                      <input
                        className="form-control input-search"
                        type="number"
                        value={templateData.fax}
                        onChange={(e) => {
                          setTemplateData({
                            ...templateData,
                            fax: e.target.value,
                          });
                        }}
                        name={`fax`}
                        placeholder="Fax"
                      />
                    </div>
                  </div>
                </FormGroup>
              </div>

              <div className="col-md-3">
                <FormGroup>
                  <Label className="col-form-label ml-2 Label-my">
                    {t("website")}
                  </Label>
                  <div className="col-xl-12">
                    <div className="input-div">
                      <input
                        className="form-control input-search"
                        type="text"
                        value={templateData.website}
                        onChange={(e) => {
                          setTemplateData({
                            ...templateData,
                            website: e.target.value,
                          });
                        }}
                        name={`website`}
                        placeholder="Website"
                      />
                      {errors.website && (
                        <span className="input-error">{errors.website}</span>
                      )}
                    </div>
                  </div>
                </FormGroup>
              </div>

              <div className="col-md-3">
                <FormGroup>
                  <Label className="col-form-label ml-2 Label-my">
                    {t("notes")}
                  </Label>
                  <div className="col-xl-12">
                    <div className="input-div">
                      <input
                        className="form-control input-search"
                        type="text"
                        value={templateData.notes}
                        onChange={(e) => {
                          setTemplateData({
                            ...templateData,
                            notes: e.target.value,
                          });
                        }}
                        name={`notes`}
                        placeholder="Notes"
                      />
                    </div>
                  </div>
                </FormGroup>
              </div>

              <div className="col-md-3">
                <FormGroup>
                  <Label className="col-form-label ml-2 Label-my">
                    {t("documents_footnote")}
                  </Label>
                  <div className="col-xl-12">
                    <div className="input-div">
                      <input
                        className="form-control input-search"
                        type="text"
                        value={templateData.documents_footnote}
                        onChange={(e) => {
                          setTemplateData({
                            ...templateData,
                            documents_footnote: e.target.value,
                          });
                        }}
                        name={`documents_footnote`}
                        placeholder="Documents footnote"
                      />
                    </div>
                  </div>
                </FormGroup>
              </div>
              <div className="col-md-3">
                <FormGroup>
                  <Label className="col-form-label ml-2 Label-my">
                    {t("email_sender_name")}
                  </Label>
                  <div className="col-xl-12">
                    <div className="input-div">
                      <input
                        className="form-control input-search"
                        type="text"
                        value={templateData.email_sender_name}
                        onChange={(e) => {
                          setTemplateData({
                            ...templateData,
                            email_sender_name: e.target.value,
                          });
                        }}
                        name={`email_sender_name`}
                        maxLength={50}
                        placeholder="Email sender name"
                      />
                    </div>
                    {errors.email_sender_name && (
                      <span className="input-error">
                        {errors.email_sender_name}
                      </span>
                    )}
                  </div>
                </FormGroup>
              </div>
              <div className="col-md-6">
                <FormGroup>
                  <Label className="col-form-label ml-2 Label-my">
                    {t("email_sender_address")}
                  </Label>
                  <div className="col-xl-12">
                    <div className="input-div">
                      <input
                        className="form-control input-search"
                        type="text"
                        value={templateData.email_sender_address}
                        onChange={(e) => {
                          setTemplateData({
                            ...templateData,
                            email_sender_address: e.target.value,
                          });
                        }}
                        name={`email_sender_address`}
                        maxLength={50}
                        placeholder="Email sender address"
                      />
                    </div>
                    {errors.email_sender_address && (
                      <span className="input-error">
                        {errors.email_sender_address}
                      </span>
                    )}
                  </div>
                </FormGroup>
              </div>

              <div className="col-md-6">
                <FormGroup>
                  <Label className="col-form-label ml-2 Label-my">
                    {t("country")}
                  </Label>
                  <div className="col-xl-12">
                    <div className="input-div">
                      <Select
                        className="my-select-v"
                        options={timeZoneList}
                        value={timeZoneList.find(
                          (item) => item.value == templateData.country_id,
                        )}
                        onChange={(selectedOption) => {
                          setTemplateData({
                            ...templateData,
                            country_id: selectedOption
                              ? selectedOption.value
                              : "",
                          });
                        }}
                        isSearchable={true}
                        isClearable={true}
                        placeholder={"Select Type"}
                      />
                      {errors.country_id && (
                        <span className="input-error">{errors.country_id}</span>
                      )}
                    </div>
                  </div>
                </FormGroup>
              </div>
            </div>
          </ModalBody>
          <ModalFooter>
            <button
              type="button"
              className="btn btn-block btn-primary"
              disabled={isModifyButtonLoad}
              onClick={handleCloseModal}
              style={{ width: "100px", marginTop: "10px" }}
            >
              {t("close")} <i className="bi bi-x-lg"></i>
            </button>
            {!isModifyButtonLoad && (
              <button
                type="submit"
                className="btn btn-block btn-primary"
                style={{ width: "100px", marginTop: "10px" }}
              >
                {t("submit")} <i className="bi bi-check2"></i>
              </button>
            )}
            {isModifyButtonLoad && (
              <Button
                color="success"
                type={`button`}
                disabled={true}
                className={`btn-square`}
              >
                <i className="fa fa-circle-o-notch fa-spin"></i> {`Loading...`}
              </Button>
            )}
          </ModalFooter>
        </Form>
      </Modal>
    </div>
  );
};

export default IdentificationTemplates;
